"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Engine = void 0;
const core_1 = require("../core");
const ActionType_1 = require("../core/actions/ActionType");
const Demand_1 = require("../core/Demand");
const Duration_1 = require("../core/Duration");
const TurnMeterDecrease_1 = require("../core/effects/core/TurnMeterDecrease");
const ApplyEffect_1 = require("../core/event-handlers/core/ApplyEffect");
const EventType_1 = require("../core/events/EventType");
const Schedule_1 = require("../core/Schedule");
const Target_1 = require("../core/Target");
class Engine {
    constructor(state = new core_1.State()) {
        this.state = state;
    }
    startTurn(actorId) {
        (0, Demand_1.demand)(this.state.getActors().length > 0, "NO_ACTORS");
        (0, Demand_1.demand)(actorId === this.state.nextActor, "START_TURN_WRONG_ACTOR");
        return this.state.useSequence("sequential", sequence => {
            return this.state.startTurn(sequence);
        });
    }
    takeTurn(actorId, action) {
        (0, Demand_1.demand)(actorId === this.state.nextActor, "TAKE_TURN_WRONG_ACTOR");
        (0, Demand_1.demand)(action.__type === ActionType_1.ActionType.UseAbility, "INVALID_ACTION_TYPE");
        const startedInRoom = this.state.currentRoom;
        return this.state.useSequence("sequential", sequence => {
            this.state.dispatch(sequence, actorId, action);
            const shouldEndTurn = !(this.state.hasActionsRemaining(this.state.nextActor) && this.state.canUseAction(this.state.nextActor));
            let shouldStartNextTurn = shouldEndTurn;
            if (!shouldEndTurn) {
                this.state.endAction(sequence, actorId);
                shouldStartNextTurn = startedInRoom !== this.state.currentRoom || this.state.adventure.state !== "Active";
            }
            return {
                shouldEndTurn,
                shouldStartNextTurn
                // : shouldEndTurn
                //   || startedInRoom !== this.state.currentRoom
                //   || this.state.adventure.state !== "Active"
            };
        });
    }
    endTurn(actorId) {
        if (actorId !== this.state.nextActor || this.state.adventure.state !== "Active") {
            return;
        }
        this.state.useSequence("sequential", sequence => {
            this.state.endTurn(sequence);
        });
    }
    registerActor(sequence, args) {
        const actorId = this.state.addActor(sequence, args);
        const actor = this.state.getActor(actorId);
        this.state.registerEventHandler(actor.id, EventType_1.EventType.Killed, Schedule_1.Schedule.Unlimited, new ApplyEffect_1.ApplyEffectEventHandlerArgs(0, Target_1.Target.Self, Duration_1.Duration.Instant, new TurnMeterDecrease_1.TurnMeterDecreaseEffectArgs(-1000, false)));
        return actorId;
    }
    nextTurnIsAi() {
        return this.state.hasAi(this.state.nextActor);
    }
    startAiTurn() {
        if (!this.nextTurnIsAi()) {
            return;
        }
        this.startTurn(this.state.nextActor);
    }
    takeAiTurn() {
        if (!this.nextTurnIsAi()) {
            return;
        }
        const actor = this.state.nextActor;
        while (this.state.canUseAction(actor) && this.state.hasActionsRemaining(actor)) {
            this.state.useSequence("sequential", sequence => {
                this.state.runAi(sequence, this.state.nextActor);
            });
        }
    }
    endAiTurn() {
        if (!this.nextTurnIsAi()) {
            return;
        }
        this.endTurn(this.state.nextActor);
    }
    isRoomCleared() {
        if (!this.state.hasCurrentRoom()) {
            return false;
        }
        return this.state.getRoom(this.state.currentRoom).state === "Cleared";
    }
}
exports.Engine = Engine;
